type CountDownType = {
  countdownDate: Date
  customCssClass?: string
  colorScheme?: keyof typeof CountDownTextColors
  onComplete?: () => void
}

export type CountDownTimerType = {
  days?: string | number
  hours?: string | number
  minutes?: string | number
  seconds?: string | number
  completed?: boolean
}

export type CountDownTimeDataType = {
  name: string
  value: string | number
}

export enum CountDownTextColors {
  'black' = 'text-black',
  'white' = 'text-white'
}

export default CountDownType
